import {Injectable} from '@angular/core';
import {JsonApiResponse, serialize, deserialize} from '@tisa-group/cdk';
import {Observable} from 'rxjs';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';

export interface OttFileUploadResponse {
  external_file_upload_path: string;
  upload_urls: string[];
  complete_upload_url: string;
}

@Injectable()
export class OttFileUploadService {
  constructor(readonly http: TisaUmpireHttpService) {}

  getPresignedURL(
    fileName: string,
    numberOfParts: number,
  ): Observable<JsonApiResponse<OttFileUploadResponse>> {
    return this.http.post(
      '/ott/file_uploads',
      serialize({
        stuff: {
          type: 'file_upload',
          file_name: fileName,
          number_of_parts: numberOfParts,
        },
      }),
    );
  }
}
